const LOAD_DETAIL_JOB_DESTINATIONS           = 'LOAD_DETAIL_JOB_DESTINATIONS'
const LOAD_DETAIL_JOB_DESTINATIONS_SUCCESS   = 'LOAD_DETAIL_JOB_DESTINATIONS_SUCCESS'
const LOAD_DETAIL_JOB_DESTINATIONS_FAILED    = 'LOAD_DETAIL_JOB_DESTINATIONS_FAILED'
const UNMOUNT_DETAIL_JOB_DESTINATIONS        = 'UNMOUNT_DETAIL_JOB_DESTINATIONS'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const jobDestinationsDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_JOB_DESTINATIONS:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_JOB_DESTINATIONS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_JOB_DESTINATIONS_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_JOB_DESTINATIONS:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default jobDestinationsDetailReducer;